module.exports = __webpack_public_path__ + "img/modern-cosmetics-2.2cbe428d.jpg";